module.exports = __webpack_public_path__ + "img/中通云仓.afed28c9.png";